export default __webpack_public_path__ + "static/folded_roof-cb0b9bcfced10c960046f864ed411182.jpg";